<!--派件报表设置-->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap" style="padding:0px 30px;">
      <el-table :data="paijians" ref="paijianRef" row-key="key" border style="width: 100%" size="mini" highlight-current-row stripe>
        <el-table-column label="派件资料">
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column type="index" min-width="100"></el-table-column>
          <el-table-column prop="key" min-width="120" :label="msg('字段KEY')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" min-width="120" :label="msg('字段NAME')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name1" min-width="120" :label="msg('字段显示名')" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.name1" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="value" min-width="120" :label="msg('固定值')" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.value" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="排序" min-width="130">
            <template slot-scope="scope">
              <i class="el-icon-rank drag-handle" draggable="true" :title="msg('按住拖动排序')"></i>
              <el-link @click="handleMoveUp(paijians, scope.$index)" icon="el-icon-top"></el-link>
              <el-link @click="handleMoveDown(paijians, scope.$index)" style="margin-left:5px;"
                       icon="el-icon-bottom"></el-link>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingReportHeimao",
  data() {
    return {
      xgroup: 'PAIJIAN_REPORT',  //电子秤group
      form: {
        pjs: [],
      },
      paijians:[
        {
          key:'currdate',
          name:'出貨日期',
          name1:'出貨日期',
          value:'',
          show:null,
        },
        {
          key:'exp_code',
          name:'黑貓換單',
          name1:'黑貓換單',
          value:'',
          show:null,
        },
        {
          key:'null',
          name:'',
          name1:'',
          value:'',
          show:null,
        },
        {
          key:'code',
          name:'訂單編號',
          name1:'訂單編號',
          value:'',
          show:null,
        },
        {
          key:'exp_pkg_code',
          name:'袋號',
          name1:'袋號',
          value:'',
          show:null,
        },
        {
          key:'kedai',
          name:'客代',
          name1:'客代',
          value:'',
          show:null,
        },
        {
          key:'receiver',
          name:'收件人姓名',
          name1:'收件人姓名',
          value:'',
          show:null,
        },
        {
          key:'receiver_tel',
          name:'收件人電話1',
          name1:'收件人電話1',
          value:'',
          show:null,
        },
        {
          key:'receiver_tel2',
          name:'收件人電話2',
          name1:'收件人電話2',
          value:'',
          show:null,
        },
        {
          key:'receiver_addr',
          name:'地址',
          name1:'地址',
          value:'',
          show:null,
        },
        {
          key:'product_name',
          name:'內容物',
          name1:'內容物',
          value:'',
          show:null,
        },
        {
          key:'count',
          name:'數量',
          name1:'數量',
          value:'',
          show:null,
        },
        {
          key:'weight_exp',
          name:'重量',
          name1:'重量',
          value:'',
          show:null,
        },
        {
          key:'amt_order',
          name:'代收金額',
          name1:'代收金額',
          value:'',
          show:null,
        },
        {
          key:'kefu',
          name:'備註',
          name1:'備註',
          value:'',
          show:null,
        },
        {
          key:'chuhuo',
          name:'出貨廠商名稱',
          name1:'出貨廠商名稱',
          value:'',
          show:null,
        },
        {
          key:'bianma',
          name:'7碼郵號',
          name1:'7碼郵號',
          value:'',
          show:null,
        },
        {
          key:'nextdate',
          name:'配送日',
          name1:'配送日',
          value:'',
          show:null,
        },
        {
          key:'shiduan',
          name:'配送時段',
          name1:'配送時段',
          value:'',
          show:null,
        },
        {
          key:'dizhi',
          name:'出貨廠商地址',
          name1:'出貨廠商地址',
          value:'',
          show:null,
        },
        {
          key:'dianhua',
          name:'出貨廠商電話',
          name1:'出貨廠商電話',
          value:'',
          show:null,
        },
        {
          key:'remark1',
          name:'',
          name1:'',
          value:'',
          show:null,
        },
        {
          key:'remark2',
          name:'',
          name1:'',
          value:'',
          show:null,
        },
      ],
      dragBound: false,
      dragFromIndex: null,
    }
  },
  mounted() {
    this.getSettings();
    this.$nextTick(() => {
      this.initRowDrag();
    });
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.pjs = [];

      let paijianReports = [];//派件报表设置

      //派件报表
      if (paijianReports.length > 0) {
        paijianReports.forEach(a => {
          if (a.xvalue) {
            let pj = {
              id: a.id ? a.id : null,
              xkey: _this.xgroup,
              owner: a.owner ? a.owner : null,
              xgroup: _this.xgroup,
              xvalue: a.xvalue,
              xtype: 1
            }
            _this.form.pjs.push(pj);
          }
        })
        let pjs = paijianReports[0];
        let pj = JSON.parse(pjs.xvalue);
        if (pj && pj.length > 0) {
          _this.paijians.splice(0, _this.paijians.length);
          pj.forEach(e => {
            _this.paijians.push(
                {
                  key: e.key,
                  name: e.name,
                  name1: e.name1,
                  value: e.value,
                  show: e.show,
                },
            )
          })
          _this.paijians.forEach(e => {
            if (e.show) {
              _this.$refs.paijianRef.toggleRowSelection(e);
            }
          })
        }
      } else {
        this.form.pjs.push({
          id: null,
          xkey: _this.xgroup,
          owner: null,
          xgroup: _this.xgroup,
          xvalue: 0,
          xtype: 0
        })
        if (this.hasPermission('stock:downloadHeimao')) {
          _this.paijians.forEach(e => {
            _this.$refs.paijianRef.toggleRowSelection(e);
          })
        }
      }
    },
    handleMoveUp(datas, index){
      if(index == 0){
        return;
      }
      let row = datas[index];
      let prevRow = datas[index-1];
      //触发数组变动
      datas.splice(index, 1, prevRow);
      datas.splice(index - 1, 1, row);
    },
    handleMoveDown(datas, index){
      if(index >= datas.length-1){
        return;
      }
      let row = datas[index];
      let lastRow = datas[index+1];
      datas.splice(index, 1, lastRow);
      datas.splice(index+1, 1, row);
    },
    initRowDrag() {
      if (this.dragBound) {
        return;
      }
      let tableEl = this.$refs.paijianRef && this.$refs.paijianRef.$el;
      if (!tableEl) {
        return;
      }
      let tbody = tableEl.querySelector('.el-table__body-wrapper tbody');
      if (!tbody) {
        return;
      }
      this.dragBound = true;
      var _this = this;
      let dragRowEl = null;

      tbody.addEventListener('dragstart', function (e) {
        let tr = e.target.closest ? e.target.closest('tr') : null;
        if (!tr) {
          e.preventDefault();
          return;
        }
        dragRowEl = tr;
        _this.dragFromIndex = Array.prototype.indexOf.call(tbody.children, tr);
        tr.classList.add('row-dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', '');
        if (e.dataTransfer.setDragImage) {
          e.dataTransfer.setDragImage(tr, 20, 20);
        }
      });

      tbody.addEventListener('dragover', function (e) {
        if (_this.dragFromIndex === null) {
          return;
        }
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        let tr = e.target.closest ? e.target.closest('tr') : null;
        if (!tr || tr === dragRowEl) {
          return;
        }
        let toIndex = Array.prototype.indexOf.call(tbody.children, tr);
        if (toIndex < 0) {
          return;
        }
        _this.moveRow(_this.dragFromIndex, toIndex);
        _this.dragFromIndex = toIndex;
      });

      tbody.addEventListener('drop', function (e) {
        e.preventDefault();
      });

      tbody.addEventListener('dragend', function () {
        if (dragRowEl) {
          dragRowEl.classList.remove('row-dragging');
        }
        dragRowEl = null;
        _this.dragFromIndex = null;
      });
    },
    moveRow(from, to) {
      if (from === to || from < 0 || to < 0 || from >= this.paijians.length || to >= this.paijians.length) {
        return;
      }
      let row = this.paijians.splice(from, 1)[0];
      this.paijians.splice(to, 0, row);
    },
    update() {
      let datas = [];
      //构建派件表
      if(this.hasPermission('stock:downloadHeimao')){
        let pj = this.form.pjs[0];
        let paijians = this.$refs.paijianRef.selection;
        if(paijians.length==0){
          this.$message(this.msg('派件字段必须选中一个'));
          return;
        }
        this.paijians.forEach(e =>{
          e.show = false;
          paijians.forEach(f => {
            if(e.key == f.key){
              e.show = true;
            }
          })
        })
        let pjvalue = JSON.stringify(this.paijians);
        datas.push({
          id: pj.id?pj.id:null,
          xkey: this.xgroup,
          owner: pj.owner?pj.owner:null,
          xgroup: this.xgroup,
          xvalue: pjvalue,
          xtype:1
        });

        var _this = this;
        _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
          _this.$message(result.msg)
        });
      }
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: move;
  margin-right: 8px;
  color: #909399;
}
.drag-handle:hover {
  color: #409EFF;
}
::v-deep .row-dragging {
  opacity: 0.6;
  background-color: #f5f7fa !important;
}
</style>
